export default __webpack_public_path__ + "static/media/delete.fd9c9b11.svg";